import { useEffect, useState } from "react";
import { fetchDepartures } from "../services/api";

export function useDepartures(packageId) {
  const [departures, setDepartures] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!packageId) return;
    setLoading(true);
    setError("");
    fetchDepartures(packageId)
      .then((data) => {
        setDepartures(data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message || "No se pudieron cargar las salidas.");
        setLoading(false);
      });
  }, [packageId]);

  return { departures, loading, error };
}
